<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/school/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش آموزشگاه {{ school.label }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="school.name" label="نام آموزشگاه"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="school.label" label="لیبل آموزشگاه"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="school.charge" hint="به تومان وارد شود."
                          label="مبلغ شارژ ماهیانه آموزشگاه"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" type="number" min="0" v-model.number="school.display_priority"
                          label="اولویت نمایش"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-switch color="success" v-model="school.is_visible" label="نمایش سمت هنرجو"></v-switch>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="edit()">ویرایش</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "SchoolEditView",
  data() {
    return {
      school: {
        name: null,
        label: null,
        charge: null,
        is_visible: true,
        display_priority: 0,
      }
    }
  },
  mounted() {
    this.getEntity()
  },
  methods: {
    getEntity() {
      window.axios.get('school/get/' + this.$route.params.id).then((res) => {
        this.school = res.data.data
      })
    },
    edit() {
      window.axios.post('school/update/'+this.$route.params.id, this.school).then(() => {
        this.openSnackbar("آموزشگاه با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.school = {
        name: null,
        label: null,
        charge: null,
        is_visible: true,
        display_priority: 0,
      }
    },
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>
